<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :title="$t('extensions.title')"
      :routeBackName="routeBackName"
    />

    <ul class="list-main-setting list-menu">
      <li class="item">
        <RowItem
          v-disable
          @click="
            closeMenu();
            $store.state.myPdfWin = true;
          "
          :title="$t('extensions.myPdfs')"
          :HasIconItem="true"
          iconItem="y"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
      <li class="item">
        <RowItem
          v-disable
          @click="openPdfImport"
          :title="$t('extensions.pdfName')"
          :HasIconItem="true"
          iconItem="y"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
    </ul>

    <div class="support-msg">
      <p class="tiny-bold-title">
        {{ $t("general.attention1") }}
      </p>
      <p>
        {{ $t("extensions.noSupportWarning1") }}
      </p>
      <p>
        <b>{{ $t("extensions.noSupportWarning3") }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import { Axios } from "@/services/_axios.js";
import menuService from "@/services/menu";
export default {
  data() {
    return {
      routeBackName: "menu-options",
      stockIcon: "fa fa-server",
      pdfIcon: "fa fa-file-pdf-o",
      // cuurentLanguage:
    };
  },
  computed: {},
  methods: {
    closeMenu() {
      menuService.closeMenu();
    },
    async openPdfImport() {
      let lang = this.userSettings.settings.lang
        ? this.userSettings.settings.lang
        : "he";

      await Axios.get("/api/pdf/open-import?lang=" + lang);
      this.closeMenu();
    },
    //
  },
};
</script>

<style lang="scss" scoped>
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
.support-msg {
  border-radius: 5px;
  background: #ebebeb;
  padding: 10px;
  width: 260px;
  margin: 31px;
}
.tiny-bold-title {
  color: #7b7b7b;
  font-size: 11px;
  font-weight: 700;
}
</style>
